import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

// The same pages are served on otocloud.io, oto.rw and their www hosts.
// Every page names its otocloud.io address so search engines rank one copy.
const PRIMARY_ORIGIN = 'https://otocloud.io';

const Canonical = () => {
    const { pathname } = useLocation();
    // Error pages (404.html) have no address of their own to name.
    if (pathname.endsWith('.html')) return null;

    const path = pathname.endsWith('/') ? pathname : `${pathname}/`;

    return (
        <Helmet>
            <link rel="canonical" href={`${PRIMARY_ORIGIN}${path}`} />
        </Helmet>
    );
};

export default Canonical;
